import { createServiceClient } from "shared/welda/services/axiosClient";

const apiPricetags = createServiceClient("/pricetags");

const createPricetaglink = async (formData) =>
  await apiPricetags.post("/createlink", formData);

const updateAllPricetags = async () => await apiPricetags.get("/updateAll");

const getAllPricetags = async () => await apiPricetags.get("/get-all");

const updatePerfionPriceByBarcode = async (articleBarcode) =>
  await apiPricetags.post("/updateperfionprice", { articleBarcode });

const pricetagsService = {
  createPricetaglink,
  updateAllPricetags,
  getAllPricetags,
  updatePerfionPriceByBarcode,
};

export default pricetagsService;
